import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=019c13f7&scoped=true&"
var script = {}
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=019c13f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c13f7",
  null
  
)

export default component.exports